module.exports = __webpack_public_path__ + "img/invite-member.18a02dd0.svg";